<template>
    <Main>
        <div slot="main" class="main">
            <div class="bank_title">
                <Header :data='headerInfo'></Header>
                <div v-if="goBackShow" class="gobcak" @click="goBack"><img src="../../assets/return.png"
                        alt=""><span>返回</span></div>
            </div>
            <div class="content">
                <div class="time_box" style="display: none;" v-if="headDate != '/nmzlqlogin'">
                    <div class="time_item" :class="{ active_item: activeItem == 0 }" @click="changeTime(0)">近7日
                    </div>
                    <div class="time_item" :class="{ active_item: activeItem == 1 }" @click="changeTime(1)">近30日
                    </div>
                    <div class="time_item" :class="{ active_item: activeItem == 2 }" @click="changeTime(2)">近3月
                    </div>
                    <div class="time_item" :class="{ active_item: activeItem == 3 }" @click="changeTime(3)">近6月
                    </div>
                    <!-- <div class="time_item" :class="{active_item: activeItem == 4}" @click="changeTime(4)">近一年
                            </div> -->
                    <div class="time_item" :class="{ active_item: activeItem == 4 }" @click="changeTime(4)">全部
                    </div>
                </div>
                <div class="t">
                    <div class="t_l">
                        <div class="t_l_content">
                            <!-- <div class="title">交易地域分布</div> -->
                            <div class="server">
                                <div>
                                    <span class="card_">交易地域分布</span>
                                    <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                                </div>
                            </div>
                            <div class="total_data">
                                <div class="total_data_item">
                                    <!-- <img src="../../assets/data_icon_001.png" alt=""> -->
                                    <div style="margin-left:0">
                                        <!-- <span style="color:#FFE11D">{{ dataInfo.tradeArealDistribution }}</span> -->
                                        <dv-digital-flop :config="config1"
                                            style="min-width:2rem;height:0.6rem;margin-left:0" />
                                        <label style="margin-top:0rem">累计综合交易金额(万)</label>
                                    </div>
                                </div>
                            </div>
                            <div v-if="isShowMap" class="map" id="mapBox"></div>
                        </div>
                    </div>
                    <div class="t_c">
                        <!-- <div class="title">活畜交易</div> -->
                        <div class="server">
                            <div>
                                <span class="card_">活畜交易</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                            <div class="date" v-show="this.headDate != '/nmzlqlogin'">
                                <span @click="cattleStatusBtn('牛')" :class="{ active: cattleStatus === '牛' }">牛</span>
                                <!-- <span @click="cattleStatusBtn('羊')" :class="{ active: cattleStatus === '羊' }">羊</span> -->
                            </div>
                        </div>
                        <div class="total_data" v-if="catSheepData">
                            <div class="total_data_item">
                                <div>
                                    <span>{{ headDate != '/nmzlqlogin' ? catSheepData.tradeMoney : 96 }}</span>
                                    <label>交易金额{{ activeItem == 4 ? '(亿)' : '(万)' }}</label>
                                </div>
                            </div>
                            <div class="total_data_item">
                                <div>
                                    <span>{{ catSheepData.tradeAmount }}</span>
                                    <label>交易数量 {{ cattleStatus == '牛' ? '(头)' : '(只)' }} </label>
                                </div>
                            </div>
                        </div>
                        <div class="subtitle">
                            <!-- <div class="subtitle_txt">
                                活畜交易趋势
                            </div> -->
                            <div class="block">
                                <span></span>
                                <span>活畜交易趋势</span>
                            </div>
                            <!-- <el-dropdown @command="selectLive">
                                <span class="el-dropdown-link">
                                    {{ currentSelect }}<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-for="(item, index) in dataInfo.liveAnimalTradeTrend"
                                        :key="index" :command='item'>{{ item.kind }}</el-dropdown-item>
                          
                                </el-dropdown-menu>
                            </el-dropdown> -->
                        </div>
                        <div id="lineChart1" class="line_chart"></div>
                        <div class="subtitle">
                            <!-- <div class="subtitle_txt">
                                活畜交易品类分布
                            </div> -->
                            <div class="block">
                                <span></span>
                                <span>活畜交易品类分布</span>
                            </div>
                        </div>
                        <!-- <div id="ringChart" class="line_chart"></div> -->
                        <div id='line_chart'></div>
                        <!-- <dv-active-ring-chart :config="config" id="line_chart" /> -->

                    </div>
                    <div class="t_c">
                        <!-- <div class="title">商品服务交易</div> -->
                        <!-- <div class="title">商城交易</div> -->
                        <div class="server">
                            <div>
                                <span class="card_">商城交易</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                        </div>
                        <div class="total_data" v-if="dataInfo.goodsServiceTrade">
                            <div class="total_data_item">
                                <!-- <img src="../../assets/data_icon_001.png" alt=""> -->
                                <div>
                                    <span>{{headDate != '/nmzlqlogin'? dataInfo.goodsServiceTrade.tradeMoney :180}}</span>
                                    <label>交易金额{{ activeItem == 4 ? '(亿)' : '(万)' }}</label>
                                </div>
                            </div>
                            <div class="total_data_item">
                                <!-- <img src="../../assets/data_icon_001.png" alt=""> -->
                                <div>
                                    <span>{{ dataInfo.goodsServiceTrade.tradeOrder }}</span>
                                    <label>交易订单(单)</label>
                                </div>
                            </div>
                        </div>
                        <div class="subtitle">
                            <!-- <div class="subtitle_txt">
                                商品交易趋势
                            </div> -->
                            <div class="block">
                                <span></span>
                                <span>商品交易趋势</span>
                            </div>
                        </div>
                        <div id="lineChart2" class="line_chart"></div>
                        <div class="subtitle">
                            <!-- <div class="subtitle_txt">
                                商品交易品类分布
                            </div> -->
                            <div class="block">
                                <span></span>
                                <span>商品交易品类分布</span>
                            </div>
                        </div>
                        <div id="barChart1" class="line_chart"></div>
                    </div>
                </div>

                <video src="../../assets/66.mp4" muted autoplay="autoplay" loop="loop"></video>
            </div>

        </div>
    </Main>
</template>

<script>
import Main from "@/components/main.vue";
import Header from "../../components/headerXn.vue";
import HighCharts from 'highcharts'
import Highcharts3D from 'highcharts/highcharts-3d';
Highcharts3D(HighCharts);
// import Charts from '@jiaminghi/charts'
export default {
    components: {
        Main,
        Header,
        // XChart
    },
    data() {
        return {
            config: {},
            config1: {},
            headerInfo: {},
            userInfo: {},
            dataInfo: {},
            currentSelect: '',
            optionData: [],
            activeItem: 0,
            cattle: [],
            cattleStatus: "牛",
            catSheepData: {},
            isShowMap: true,//底图显示 
            goBackShow: false,//上一层
            region: {},
            chart: {},
            dataArr: [],
            flowData: [],
            paramsName: '',//下钻保存的省名
            num1: 0,
            num2: 0,
            headDate: '',//判断是否为正蓝旗登录
            mapData: [
                { name: '赛音呼都嘎苏木乡', city: '赛音呼都嘎苏木乡', value: 480, position: [116.058430112977, 42.7826140522395] }
            ],

            mapDistance:90, //地图缩放距离
            mapDistance2:90 //子地图缩放距离
        };
    },
    created() {
        this.headDate = window.localStorage.getItem('LOGIN')
        this.headerInfo = {
            name: window.localStorage.getItem('screenName')
        }
        this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))

    },
    mounted() {
        // this.getMap()
        this.getData()
        // const lineData = [{
        //     label:['2022-04', '2022-05', '2022-06', '2022-07', '2022-08', '2022-09'],
        //     "title":"屠宰交易",
        //     value: [500, 200, 4000, 1500, 900, 2300]
        // }]
        // this.setLineData(lineData, 'lineChart1')
        // this.setLineData(lineData, 'lineChart2')

        // this.setBarData({
        //     dom: 'barChart1',
        //     data: [
        //         {
        //             label: ['2022-04', '2022-05', '2022-06', '2022-07', '2022-08', '2022-09'],
        //             value: [500, 200, 4000, 1500, 900, 2300],
        //             colors: ['#297DFC', '#06FDF5']
        //         }
        //     ]
        // })



        // const lineData1 = [{
        //     label:['2022-04', '2022-05', '2022-06', '2022-07', '2022-08', '2022-09'],
        //     "title":"屠宰交易",
        //     value: [500, 200, 4000, 1500, 900, 2300]
        // }, {
        //     label:['2022-04', '2022-05', '2022-06', '2022-07', '2022-08', '2022-09'],
        //     "title":"屠宰交易",
        //     value: [500, 200, 4000, 1500, 900, 300]
        // }]

    },
    methods: {

        // 返回上一层
        goBack() {
            this.goBackShow = false
            // this.$router.go(0)
            this.activeItem = 0
            this.isShowMap = false
            this.getData()
        },
        cattleStatusBtn(val) {
            if (val === '牛') {
                this.cattleStatus = '牛'
                // const dataArr = []
                // this.entityDis.cow.label.forEach(item => {
                //     dataArr.push({ name: item })
                // })
                // this.entityDis.cow.value.forEach((item, i) => {
                //     dataArr[i].value = item
                // })
                // this.config = {
                //     data: dataArr,
                //     unit: '头'
                // }
            }
            if (val === '羊') {
                this.cattleStatus = '羊'
                // const dataArr = []
                // this.entityDis.sheep.label.forEach(item => {
                //     dataArr.push({ name: item })
                // })
                // this.entityDis.sheep.value.forEach((item, i) => {
                //     dataArr[i].value = item
                // })
                // this.config = {
                //     data: dataArr,
                //     unit: '头'
                // }
            }
            this.changeLineData()
        },
        changeTime(status) {
            if (this.chart != null && this.chart != "" && this.chart != undefined) {
                this.isShowMap = false
            }
            this.activeItem = status
            this.getData()
        },
        getData() {
            // this.dataInfo = data
            // this.setLineData(this.dataInfo.tradePrice, 'lineChart3')
            // this.selectLive(this.dataInfo.liveAnimalTradeTrend[0])

            // this.dataInfo.entranceQuantity.forEach((item, index) => {
            //     if(index == 0) {
            //         item.colors = ['#5630F5', '#7855FA']
            //     } else {
            //         item.colors = ['#297DFC', '#06FDF5']
            //     }
            // })

            // this.$nextTick(() => {
            //     this.setRingChart(this.dataInfo.kindDistribution)
            //     this.setBarData({
            //         dom: 'barChart2',
            //         data: this.dataInfo.entranceQuantity
            //     })
            //     this.setLineData([this.dataInfo.goodsServiceTradeTrend], 'lineChart2')
            //     this.setBarData({
            //         dom: 'barChart1',
            //         data: [
            //             {
            //                 ...this.dataInfo.goodsTradeKindDistribution,
            //                 colors: ['#297DFC', '#06FDF5']
            //             }
            //         ]
            //     })
            //     this.dataInfo.totalAllAmount.forEach(item => {
            //         item.name = item.city
            //     })
            //     this.draw(this.region, this.dataInfo.totalAllAmount)
            // })
            this.$http({
                // url: 'screenapp-service/baseBigScreen/select',
                url: 'screenapp-service/baseBigScreen/select/transactionAnalysis',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    parentId: '0',
                    menuMark: '2',
                    flag: this.activeItem,
                    deptId: this.userInfo.dept.deptId,
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    const screenData = JSON.parse(data.result.screenData)
                    this.dataInfo = screenData
                    if (this.goBackShow) {
                        var a = this.dataInfo.totalAllAmount.filter(item => {
                            return item.city == this.paramsName
                        })
                        this.dataInfo = a[0].childData
                        this.dataInfo['childMap'] = a[0].childMap
                    }
                    if(this.dataInfo.mapDistance){
                        this.mapDistance = Number(this.dataInfo.mapDistance);
                    }
                    console.log(this.dataInfo, ';dataInfo');
                    this.getList()
                } else {
                    // this.$message.error(data);
                }
            })
        },
        getList() {
            this.config1 = {
                number: [0],
                style: {
                    //这里可以修改默认样式
                    fontSize: 32,//字体大小
                    fill: '#FFE11D',//字体颜色
                },
                textAlign: 'left',
                toFixed: this.activeItem == 4 ? 2 : 0,
            }
            setTimeout(() => {
                console.log(this.dataInfo.tradeArealDistribution)
                this.config1 = {
                    number: [this.dataInfo.tradeArealDistribution],
                    style: {
                        //这里可以修改默认样式
                        fontSize: 32,//字体大小
                        fill: '#FFE11D',//字体颜色
                    },
                    textAlign: 'left',
                    toFixed: this.activeItem == 4 ? 2 : 0,
                }
            }, 0)
            this.cattle = this.dataInfo.purchasePriceTrend

            // this.dataInfo.entranceQuantity.forEach((item, index) => {
            //     if (index == 0) {
            //         item.colors = ['#00ACFB', '#2C9FFD']
            //     } else {
            //         item.colors = ['#31FEF9', '#04E1DD']
            //     }
            // })

            this.$nextTick(() => {
                // if (this.headDate != '/nmzlqlogin') {
                //     this.setLineData(this.dataInfo.tradePrice, 'lineChart3', '金额(元)')
                //     this.setBarData({
                //         dom: 'barChart2',
                //         data: this.dataInfo.entranceQuantity
                //     })
                // } else {
                //     var dataArr1 = [this.dataInfo.tradePrice[0]]//活畜收购趋势图
                //     var dataArr2 = [this.dataInfo.entranceQuantity[0]]//屠宰收购交易柱状图
                //     this.setLineData(dataArr1, 'lineChart3', '金额(元)')
                //     this.setBarData({
                //         dom: 'barChart2',
                //         data: dataArr2
                //     })
                // }
                this.cattleStatusBtn(this.dataInfo.liveAnimalTrade.cow.kind)
                this.setLineData([this.dataInfo.goodsServiceTradeTrend], 'lineChart2')
                this.setBarData({
                    dom: 'barChart1',
                    data: [
                        {
                            ...this.dataInfo.goodsTradeKindDistribution,
                            colors: ['#0BE5E1', '#06FDF5']
                        }
                    ]
                })
                if (!this.goBackShow) {
                    this.dataInfo.totalAllAmount.forEach(item => {
                        item.name = item.city
                    })
                }

                // this.dataInfo.kindDistribution.forEach(item => {
                //     this.dataArr.push({ name: item.label, value: item.label })
                // })
                // this.setRingChart(this.dataInfo.kindDistribution)       
                if (!this.goBackShow) {
                    this.getMap()
                } else {
                    if (this.chart != null && this.chart != "" && this.chart != undefined) {
                        this.isShowMap = false
                    }
                    this.$nextTick(() => {
                        this.isShowMap = true
                        this.$nextTick(() => {
                            this.drawMap(this.region, this.dataInfo.childMap)
                        })
                    })
                }
            })
        },
        // 正蓝旗
        draws(geoJson) {
            // console.log(geoJson,'geoJson');
            // console.log(geoJson, 234);
            // console.log(data, 123);
            // 基于准备好的dom，初始化echarts实例
            this.chart = this.$echarts.init(document.getElementById("mapBox"));
            this.$echarts.registerMap('GD', geoJson);
            let data = [
                ['116.158430112977', '42.8426140522395', 260],//赛音呼都嘎苏木乡
                ['115.887591014485', '42.9047850462557', 286],//那日图苏木乡
                ['115.936932911947', '41.9696109107532', 224],//黑城子示范区
                ['115.580376925441', '42.8669839246449', 287],//扎格斯台苏木乡
                ['115.641299118031', '42.2547129144455', 454],//哈毕日嘎镇
                ['115.613881921393', '42.5079359815629', 234],//宝绍代苏木乡
                // ['115.724337808832', '42.2433489074685', 500],//上都镇
                // ['115.764337808832', '42.2833489074685', 490],//上都镇
                ['115.904337808832', '42.3033489074685', 480],//上都镇
                ['115.864337808832', '42.2433489074685', 500],//上都镇
                ['116.231843112159', '42.3435590074122', 310],//五一种畜场总场
                ['115.893910088668', '42.580423003749', 341],//桑根达来镇
            ];
            let areaData = [];
            data.map((item) => {
                // 扩大热力图效果
                areaData.push(...new Array(4).fill(item));
            });
            let mapMax = Math.max(...data.map((item) => item[2]));
            let mapMin = Math.min(...data.map((item) => item[2]));


            var option = {
                tooltip: {
                    label: {
                        show: false,
                    },
                    textStyle: {
                        color: '#fff'
                    },
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: (params) => {
                        // console.log(params, 'params');
                        return `
                            <p style="color:#00d4cf;font-size: 20px;">${params.name}</p><br/>
                          
                                  `;
                    },
                },
                visualMap: {
                    type: 'continuous',
                    show: true,
                    calculable: false,
                    right: 30,
                    bottom: 20,
                    itemWidth: 13,//图形的宽度，即长条的宽度。
                    itemHeight: 80,
                    // showLabel: !0,
                    text: [`${mapMax}`, '0'],
                    // realtime: false,
                    // calculable: true,
                    color: ['#fa0023', '#84d100', '#90ff07', '#edcc00', '#004684'],
                    min: mapMin,
                    max: mapMax,
                    // continuous: {
                    //     type: 'piecewise',
                    // itemGap: 12,
                    align: 'left',
                    // itemSymbol: 'circle',
                    // itemWidth: 8,
                    // itemHeight: 8,
                    textStyle: { color: '#fff' },
                },

                grid: {
                    height: '100%',
                    width: '100%',
                },

                geo: [
                    {
                        map: 'GD',
                        top: 'center',
                        left: '30%',
                        roam: false,
                        // width: '90%',
                        // height: '95%',
                        zoom: 1,
                        // z: 1,
                        label: {
                            normal: {
                                show: false,
                                color: 'transparent',
                                fontSize: 22,
                            }
                        },
                        emphasis: {
                            // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                            label: {
                                // label高亮时的配置
                                show: false,
                                textStyle: {
                                    color: "#fff", // 高亮时标签颜色变为 白色
                                    fontSize: 15, // 高亮时标签字体 变大
                                },
                                // formatter: function (params) {
                                //   // console.log(params)
                                //   return params.name
                                // }
                            },
                            itemStyle: {
                                "areaColor": "#1E88E5"
                            }
                        },
                        itemStyle: {
                            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                            // color: "rgba(33,80,231,1)", // 地图板块的颜色
                            color: '#0f3a67',
                            opacity: 1, // 图形的不透明度 [ default: 1 ]
                            borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                            borderColor: "#37C1FD", // 图形描边的颜色。[ default: #333 ]
                            normal: { // 默认地图区域样式
                                // areaColor: 'rgba(33,80,231,1)',
                                areaColor: "#0f3a67",
                                // borderColor: "#4ECEE6",
                                borderColor: "#165d7d",
                                borderWidth: 1,
                                // shadowColor: "#2C99F6",
                                // shadowOffsetY: 0,
                                // shadowBlur: 25,
                            },
                        },
                    },
                    // {
                    //     map: 'GD',
                    //     roam: false, //是否允许缩放
                    //     zoom: 0.9,
                    //     left: '100',
                    //     top: '25',
                    //     width: '90%',
                    //     height: '95%',
                    //     itemStyle: {
                    //         areaColor: `transparent`,
                    //         borderColor: `#004094`,
                    //     },
                    //     z: 0,
                    //     silent: true,
                    // },
                    // {
                    //     map: 'GD',
                    //     roam: false, //是否允许缩放
                    //     zoom: 0.9,
                    //     left: '100',
                    //     top: '29',
                    //     width: '90%',
                    //     height: '95%',
                    //     itemStyle: {
                    //         areaColor: `transparent`,
                    //         borderColor: `#013164`,
                    //     },
                    //     z: 0,
                    //     silent: true,
                    // },
                    // {
                    //     map: 'GD',
                    //     roam: false, //是否允许缩放
                    //     zoom: 0.9,
                    //     left: '100',
                    //     top: '34',
                    //     width: '90%',
                    //     height: '95%',
                    //     itemStyle: {
                    //         areaColor: `transparent`,
                    //         borderColor: `#013164`,
                    //     },
                    //     z: 0,
                    //     silent: true,
                    // },
                ],

                series: [
                    {
                        mapType: 'GD',
                        name: 'AQI',
                        type: 'heatmap',
                        coordinateSystem: 'geo',
                        data: areaData
                    },

                ],
            }
            this.chart.clear();
            this.chart.setOption(option);
            // chart.on('click', (ret) => {
            //     console.log(ret,'wodianle');
            // })
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
        drawsss(geoJson, data) {
            console.log(data, '111');
            console.log(geoJson, 234);
            // 基于准备好的dom，初始化echarts实例
            this.chart = this.$echarts.init(document.getElementById("mapBox"));
            // bayannaoer
            this.$echarts.registerMap("bayannaoer", geoJson);
            // 隐藏动画加载效果。
            this.chart.hideLoading();
            var option = {
                grid: {
                    // top: '30%',
                    // height: "400px",
                    // containLabel: true,
                },
                select: {
                    disabled: true,
                    itemStyle: {
                        areaColor: "#1E88E5",
                        borderColor: "#21bde6",
                        borderWidth: "1"
                    },
                    label: {
                        show: false,
                        color: '#fff',
                        position: 'top'
                    },
                },
                blur: {
                    itemStyle: {
                        areaColor: "#1E88E5",
                        borderColor: "#21bde6",
                        borderWidth: "1"
                    }
                },
                tooltip: {
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    formatter: function (params) {
                        // console.log(params, 'params');
                        return `
                            <p style="color:#00E0DB;font-size: 20px;">${params.name}</p><br/>
                          
                                  `;
                        //         <p>
                        //  <span style="color: #FFF; font-size: 14px; font-weight: normal;">${params.data.code == "养殖户分布" ? '养殖户数量' : '活畜数量'}<span style="color: #00E0DB; font-size: 16px;">${params.data.value || 0}</span><span style="color: #fff; font-size: 16px; font-weight: normal;">${params.data.code == "养殖户分布" ? "家" : '头'}</span> </span>
                        //         </p>
                    },
                },
                series: [
                    {
                        type: "map", // 系列类型
                        name: "map", // 系列名称
                        zoom: 1,
                        // roam: true,
                        map: "bayannaoer", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                        data: data ? data : [],
                        label: {
                            // properties.cp
                            // 标签的相关设置
                            show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                            // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                            position: 'top',
                            // offset: [-10, 5],
                            textStyle: {
                                // 标签的字体样式
                                color: "white", // 地图初始化区域字体颜色
                                fontSize: 8, // 字体大小
                                opacity: 1, // 字体透明度
                                backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                            },
                        },
                        itemStyle: {
                            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                            // color: "rgba(33,80,231,1)", // 地图板块的颜色
                            color: '#0f3a67',
                            opacity: 1, // 图形的不透明度 [ default: 1 ]
                            borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                            borderColor: "#37C1FD", // 图形描边的颜色。[ default: #333 ]
                            normal: { // 默认地图区域样式
                                // areaColor: 'rgba(33,80,231,1)',
                                areaColor: "#0f3a67",
                                // borderColor: "#4ECEE6",
                                borderColor: "#165d7d",
                                borderWidth: 1,
                                // shadowColor: "#2C99F6",
                                // shadowOffsetY: 0,
                                // shadowBlur: 25,
                            },
                        },

                        emphasis: {
                            // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                            label: {
                                // label高亮时的配置
                                show: false,
                                textStyle: {
                                    color: "#fff", // 高亮时标签颜色变为 白色
                                    fontSize: 15, // 高亮时标签字体 变大
                                },
                                // formatter: function (params) {
                                //   // console.log(params)
                                //   return params.name
                                // }
                            },
                            itemStyle: {
                                "areaColor": "#1E88E5"
                            }
                        }
                    },
                    {
                        name: 'AQI',
                        type: 'heatmap',
                        coordinateSystem: 'geo',
                        data: data

                    }
                ],

            }
            this.chart.clear();
            this.chart.setOption(option);
            // chart.on('click', (ret) => {
            //     console.log(ret,'wodianle');
            // })
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
        },
        flowChart() {
            var myChart = this.$echarts.init(document.getElementById('line_chart'));
            var option = {
                color: ['#0EDAE2', '#5D2CFE', '#E7C660', '#2C76FE'],
                grid: {
                    top: '20%',
                    left: '10%',
                    height: '60px',
                },
                tooltip: {
                    trigger: 'item',
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                    padding: 5,
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    // formatter: function (params) {
                    //     // console.log(params, 2)
                    //     return `
                    //     <p>
                    //       <span style="font-size: 14px; font-weight: normal;">${params.data.name + `(笔)`}： ${params.data.value || 0} </span>
                    //     </p><br/> 
                    //      `;
                    // },
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '70%'],
                        // avoidLabelOverlap: false,
                        label: {
                            show: true,
                            position: 'outside',
                            color: '#FFFFFF',
                            // formatter: ' {b} {d}% \n\n',
                            formatter: function (params) {
                                if (params.percent === undefined) {
                                    return params.name + 0 + '% \n\n'
                                } else if (params.percent === 0) {
                                    return params.name + params.percent + '% \n\n'
                                } else {
                                    return params.name + params.percent + '% \n\n'
                                }
                            },
                            padding: [0, -50],
                            alignTo: 'labelLine'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                // fontSize: '40',
                                // fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true,
                            length: 5,
                            length2: 60,
                            lineStyle: {
                                color: '#73c0de',
                            }
                        },
                        data: this.flowData
                    }
                ]
            };
            myChart.clear();
            myChart.setOption(option)
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        },
        // selectLive(command) {
        //     this.currentSelect = command.kind;
        //     this.changeLineData()
        // },
        changeLineData() {
            // this.dataInfo.liveAnimalTradeTrend.forEach(item => {
            //     if (this.currentSelect === item.kind) {
            //         this.setLineData([item], 'lineChart1')
            //     }
            // })
            for (var key in this.dataInfo.liveAnimalTrade) {
                if (this.cattleStatus == this.dataInfo.liveAnimalTrade[key].kind) {
                    this.catSheepData = this.dataInfo.liveAnimalTrade[key]
                    console.log(this.dataInfo.liveAnimalTrade[key], 'this.dataInfo.liveAnimalTrade[key]');
                    this.flowData = []
                    if (this.cattleStatus == '羊') {
                        // ------------------------------
                        // this.catSheepData.tradeAmount = 0
                        // this.catSheepData.tradeMoney = 0
                        this.dataInfo.liveAnimalTrade[key].value = this.dataInfo.liveAnimalTrade[key].value.map((it) => {
                            return it = 0
                        })
                        // -------------------------------
                        this.dataArr = this.dataInfo.liveAnimalTrade[key].sheepKindDis
                        // this.flowData = [
                        //     { name: this.dataArr[0].label, value: this.dataArr[0].value },
                        //     { name: this.dataArr[1].label, value: this.dataArr[1].value },
                        //     { name: this.dataArr[2].label, value: this.dataArr[2].value },
                        // ]

                    } else {
                        this.dataArr = this.dataInfo.liveAnimalTrade[key].kindDistribution
                        // this.flowData = [
                        //     { name: this.dataArr[0].label, value: this.dataArr[0].value },
                        //     { name: this.dataArr[1].label, value: this.dataArr[1].value },
                        //     { name: this.dataArr[2].label, value: this.dataArr[2].value },
                        //     { name: this.dataArr[3].label, value: this.dataArr[3].value },
                        // ]
                    }
                    this.dataArr.forEach(item => {
                        // if (this.cattleStatus == '羊') {
                        //     this.flowData.push({ name: item.label, value: 0 })
                        // }
                        // else {
                            this.flowData.push({ name: item.label, value: item.value })
                        // }
                    })
                    this.setLineData([this.dataInfo.liveAnimalTrade[key]], 'lineChart1')
                    this.flowChart()
                }
            }
            // this.dataInfo.liveAnimalTradeTrend.forEach(item => {
            //     if (this.cattleStatus === item.kind) {
            //         this.setLineData([item], 'lineChart1')
            //     }
            // })
        },
        getMap() {
            this.$http({
                url: 'screenapp-service/baseScreenEnterpriseInfo/select/mapData',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deptId: this.userInfo.dept.deptId,
                },
            }).then(res => {
                if (res.data.code === 200) {
                    this.region = res.data.result.json;
                    // this.getData()
                    // this.draw(this.region, this.dataInfo.totalAllAmount)
                    if (this.chart != null && this.chart != "" && this.chart != undefined) {
                        this.isShowMap = false
                    }
                    this.$nextTick(() => {
                        this.isShowMap = true
                        this.$nextTick(() => {
                            console.log(this.region.features[0], '4545');
                            if (this.region.features[0].properties.country == '正蓝旗') {
                                this.draws(this.region, this.mapData)
                            } else {
                                this.drawMap(this.region, this.dataInfo.totalAllAmount)
                            }
                        })
                    })
                    // this.shows = true
                }
            })
        },
        // 地图
        drawMap(geoJson, data) {
            // console.log(data);
            if (data) {
                data.forEach(item => {
                    item.name = item.city
                    item.value = item.totalAmount
                    // item.code = this.arr[1]
                })
                var arrData = data.map(item => {
                    return item.value
                })
                arrData = arrData.sort((a, b) => {
                    return a - b
                })
                this.num1 = Number((arrData[arrData.length - 1] / 5).toFixed(0))
                this.num2 = Number(arrData[arrData.length - 1])
            }
            this.chart = this.$echarts.init(document.getElementById("mapBox"));
            // geoJson.features.forEach((item) => {
            //     item['properties']['cp'] = item.properties.center
            // })
            this.$echarts.registerMap("bayannaoer", geoJson);
            // 隐藏动画加载效果。
            this.chart.hideLoading();
            var option = {
                tooltip: {
                    show:false,
                    // 提示框
                    trigger: "item",
                    borderColor: "#00E0DB",
                    borderWidth: 1,
                    padding: 5,
                    backgroundColor: "#030b14",
                    extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
                    // formatter: function (params) {
                    //     // console.log(params, 'params');
                    //     return `
                    //     <p style="color:#00E0DB;font-size: 20px;">${params.data.name}</p><br/>
                    //     <p>
                    //    <span style="color: #FFF; font-size: 14px; font-weight: normal;">${params.data.code == "存栏分布" ? '存栏分布' : params.data.code == "疾病分布" ? '疾病分布' : params.data.code == "繁殖率分布" ? '繁殖率分布' : ''}
                    //     <span style="color: #00E0DB; font-size: 16px;">${params.data.value || 0}</span><span style="color: #fff; font-size: 16px; font-weight: normal;">${params.data.code == "繁殖率分布" ? "" : '头'}</span> </span>
                    //           </p>
                    //           `;
                    // },
                    formatter: function (params) {
                        return `<p>
                            <span style="color:#00E0DB;font-size: 20px; font-weight: normal;">${params.name
                            }</span>
                            <br>
                            <span style="color: #FFF; font-size: 14px; font-weight: normal;">累计综合交易金额(万)： <span style="color: #00E0DB; font-size: 16px;">${params.data.totalAmount || 0}</span></span>
                            <br>
                            <span style="color: #FFF; font-size: 14px; font-weight: normal;">活畜交易(万)： <span  style="color: #00E0DB; font-size: 16px;">${params.data.liveAnimalTrade || 0}</span></span>
                            <br>
                            <span style="color: #FFF; font-size: 14px; font-weight: normal;">商品服务交易(万)： <span  style="color: #00E0DB; font-size: 16px;">${params.data.goodsServiceTrade || 0}</span></span>
                            <br>
                            <span style="color: #FFF; font-size: 14px; font-weight: normal;">屠宰交易(万)： <span  style="color: #00E0DB; font-size: 16px;">${params.data.slaughter || 0}</span></span>
                            
                        </p>`;
                    },
                },
                grid: {
                    // top: '-5%',
                    // show:true
                },
                series: [
                    {
                        type: "map3D", // 系列类型
                        name: "map3D", // 系列名称
                        zoom: 1,
                        map: "bayannaoer", // 地图类型。echarts-gl 中使用的地图类型同 geo 组件相同(ECharts 中提供了两种格式的地图数据，一种是可以直接 script 标签引入的 js 文件，引入后会自动注册地图名字和数据。还有一种是 JSON 文件，需要通过 AJAX 异步加载后手动注册。)
                        data: data ? data : [],
                        top: '-1%',
                        // bottom:'50%',
                        label: {
                            // properties.cp
                            // 标签的相关设置
                            show: false, // (地图上的城市名称)是否显示标签 [ default: false ]
                            // distance: 10, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离 标签内容格式器
                            position: 'top',
                            // offset: [-10, 5],
                            textStyle: {
                                // 标签的字体样式
                                color: "white", // 地图初始化区域字体颜色
                                fontSize: 12, // 字体大小
                                opacity: 1, // 字体透明度
                                backgroundColor: "rgba(0,23,11,0)", // 字体背景色
                            },
                            // align: 'center',
                            // verticalAlign: 'middle'
                            // normal: {
                            //     show: true,
                            //     color: 'rgba(5, 176, 220, 1)',
                            //     fontSize: 1, //此处字体需做兼容适配

                            //     align: 'left',
                            //     verticalAlign: 'middle',
                            //     position: 'inside',
                            //     distance: 15,
                            // },
                            // emphasis: {
                            //     show: true,
                            //     color: '#ececec'
                            // }
                        },
                        itemStyle: {
                            // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
                            // color: "rgba(33,80,231,1)", // 地图板块的颜色
                            color: '#17478F',
                            opacity: 1, // 图形的不透明度 [ default: 1 ]
                            borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
                            borderColor: "#00ffff", // 图形描边的颜色。[ default: #333 ]
                        },

                        emphasis: {
                            // 鼠标 hover 高亮时图形和标签的样式 (当鼠标放上去时 label和itemStyle 的样式)
                            label: {
                                // label高亮时的配置
                                show: false,
                                textStyle: {
                                    color: "#fff", // 高亮时标签颜色变为 白色
                                    fontSize: 15, // 高亮时标签字体 变大
                                },
                                // formatter : function(params) {
                                //     console.log(params)
                                // }
                            },
                            itemStyle: {
                                "color": "#00E0DB"
                            }
                        },
                        groundPlane: {
                            // 地面可以让整个组件有个“摆放”的地方，从而使整个场景看起来更真实，更有模型感。
                            show: false, // 是否显示地面。[ default: false ]
                            color: "#aaa", // 地面颜色。[ default: '#aaa' ]
                        },
                        light: {
                            // 光照相关的设置。在 shading 为 'color' 的时候无效。 光照的设置会影响到组件以及组件所在坐标系上的所有图表。合理的光照设置能够让整个场景的明暗变得更丰富，更有层次。
                            main: {
                                // 场景主光源的设置，在 globe 组件中就是太阳光。
                                color: "#fff", //主光源的颜色。[ default: #fff ]
                                intensity: 1.2, //主光源的强度。[ default: 1 ]
                                shadow: false, //主光源是否投射阴影。默认关闭。 开启阴影可以给场景带来更真实和有层次的光照效果。但是同时也会增加程序的运行开销。
                                shadowQuality: "medium", // 阴影的质量。可选'low', 'medium', 'high', 'ultra' [ default: 'medium' ]
                                alpha: 55, // 主光源绕 x 轴，即上下旋转的角度。配合 beta 控制光源的方向。[ default: 40 ]
                                beta: 10, // 主光源绕 y 轴，即左右旋转的角度。[ default: 40 ]
                            },
                        },

                        viewControl: {
                            // 用于鼠标的旋转，缩放等视角控制。
                            projection: "perspective", // 投影方式，默认为透视投影'perspective'，也支持设置为正交投影'orthographic'。
                            autoRotate: false, // 是否开启视角绕物体的自动旋转查看。[ default: false ]
                            autoRotateDirection: "cw", // 物体自传的方向。默认是 'cw' 也就是从上往下看是顺时针方向，也可以取 'ccw'，既从上往下看为逆时针方向。
                            autoRotateSpeed: 10, // 物体自传的速度。单位为角度 / 秒，默认为10 ，也就是36秒转一圈。
                            autoRotateAfterStill: 3, // 在鼠标静止操作后恢复自动旋转的时间间隔。在开启 autoRotate 后有效。[ default: 3 ]
                            damping: 0, // 鼠标进行旋转，缩放等操作时的迟滞因子，在大于等于 1 的时候鼠标在停止操作后，视角仍会因为一定的惯性继续运动（旋转和缩放）。[ default: 0.8 ]
                            rotateSensitivity: 0, // 旋转操作的灵敏度，值越大越灵敏。支持使用数组分别设置横向和纵向的旋转灵敏度。默认为1, 设置为0后无法旋转。 rotateSensitivity: [1, 0]——只能横向旋转； rotateSensitivity: [0, 1]——只能纵向旋转。
                            zoomSensitivity: 0, // 缩放操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法缩放。
                            panSensitivity: 1, // 平移操作的灵敏度，值越大越灵敏。默认为1,设置为0后无法平移。支持使用数组分别设置横向和纵向的平移灵敏度
                            panMouseButton: "left", // 平移操作使用的鼠标按键，支持：'left' 鼠标左键（默认）;'middle' 鼠标中键 ;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
                            rotateMouseButton: "left", // 旋转操作使用的鼠标按键，支持：'left' 鼠标左键;'middle' 鼠标中键（默认）;'right' 鼠标右键(注意：如果设置为鼠标右键则会阻止默认的右键菜单。)
                            orthographicSize: 60,
                            // distance: 200, 
                            distance: this.mapDistance, // [ default: 100 ] 默认视角距离主体的距离，对于 grid3D 和 geo3D 等其它组件来说是距离中心原点的距离,对于 globe 来说是距离地球表面的距离。在 projection 为'perspective'的时候有效。
                            minDistance: 40, // [ default: 40 ] 视角通过鼠标控制能拉近到主体的最小距离。在 projection 为'perspective'的时候有效。
                            maxDistance: 400, // [ default: 400 ] 视角通过鼠标控制能拉远到主体的最大距离。在 projection 为'perspective'的时候有效。
                            alpha: 70, // 视角绕 x 轴，即上下旋转的角度。配合 beta 可以控制视角的方向。[ default: 40 ]
                            beta: 10, // 视角绕 y 轴，即左右旋转的角度。[ default: 0 ]
                            // minAlpha: -45, // 上下旋转的最小 alpha 值。即视角能旋转到达最上面的角度。[ default: 5 ]
                            // maxAlpha: 45, // 上下旋转的最大 alpha 值。即视角能旋转到达最下面的角度。[ default: 90 ]
                            // minBeta: -45, // 左右旋转的最小 beta 值。即视角能旋转到达最左的角度。[ default: -80 ]
                            // maxBeta: 45, // 左右旋转的最大 beta 值。即视角能旋转到达最右的角度。[ default: 80 ]
                            // center: [0, 0, 0], // 视角中心点，旋转也会围绕这个中心点旋转，默认为[0,0,0]。
                            animation: true, // 是否开启动画。[ default: true ]
                            animationDurationUpdate: 1000, // 过渡动画的时长。[ default: 1000 ]
                            animationEasingUpdate: "cubicInOut", // 过渡动画的缓动效果。[ default: cubicInOut ]
                        },
                    },
                ],
                visualMap: {
                    show:false,
                    type: 'continuous',
                    // show: true,
                    min: 0,
                    max: this.num1 ? this.num1 * 4 : 0, //控制根据返回值  控制数量
                    right: 15,
                    bottom: 20,
                    itemWidth: 13,//图形的宽度，即长条的宽度。
                    itemHeight: 80,
                    // showLabel: !0,
                    text: [`${this.num2}`, '0'],
                    // realtime: false,
                    // calculable: true,
                    inRange: {
                        color: this.num1 ? ['rgba(16,53,95,0.4)', 'rgba(250,219,114,1)', 'rgba(244,165,47,1)',
                            'rgba(242,150,43,1)', 'rgba(247,130,24,1)', 'rgba(249,105,33,1)'] : ['rgba(16,53,95,0.4)']  //显示颜色
                    },
                    // continuous: {
                    //     type: 'piecewise',
                    // itemGap: 12,
                    align: 'left',
                    // itemSymbol: 'circle',
                    // itemWidth: 8,
                    // itemHeight: 8,
                    textStyle: { color: '#fff' },
                    pieces: [{
                        gte: this.num1 * 4,
                        label: `${this.num1 * 4}以上`,
                        // color: "#6b3e35"
                        color: "#f96921",
                        opacity: 1
                    }, {
                        gte: this.num1 * 3,
                        lte: this.num1 * 4,
                        label: `${this.num1 * 3} - ${this.num1 * 4}`,
                        color: "#f78218",
                        opacity: 1
                        // color: "#4a383f"
                    },
                    {
                        gte: this.num1 * 2,
                        lte: this.num1 * 3,
                        label: `${this.num1 * 2}-${this.num1 * 3}`,
                        color: "#f2962b",
                        opacity: 1
                        // color: "#303345"
                    }, {
                        gte: this.num1,
                        lte: this.num1 * 2,
                        label: `${this.num1}-${this.num1 * 2}`,
                        color: '#f4a52f',
                        opacity: 1
                        // color: "#192f4d"
                    }, {
                        gte: 1,
                        lte: this.num1,
                        label: `1-${this.num1}`,
                        // color: "#112e50"
                        color: "#fadb72",
                        opacity: 1
                    }, {
                        gte: 0,
                        lte: 0,
                        // color: "#112e50"
                        color: "#10355F",
                        opacity: .4,
                    }
                    ],
                },
            };

            this.chart.setOption(option)
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
            // this.chart.on('click', (params) => {
            //     // if (params.name == '锡林郭勒盟') {
            //     this.region.features.forEach((item) => {
            //         if (item.properties.name == params.name) {
            //             // console.log(item.properties.name);
            //             var a = this.dataInfo.totalAllAmount.filter(item => {
            //                 if (item.name == params.name) {
            //                     this.paramsName = params.name
            //                     return item
            //                 }
            //             })
            //             // console.log(a, 'a');
            //             this.dataInfo = a[0].childData
            //             // console.log(this.dataInfo, 'this.dataInfowew');
            //             this.goBackShow = true
            //             // this.getList()
            //             var adcode = item.properties.adcode
            //             this.$http({
            //                 url: 'screenapp-service/map/child/data',
            //                 //请求方式
            //                 method: 'post',
            //                 //传递的参数
            //                 data: {
            //                     adcode: adcode,
            //                 },
            //             }).then(res => {
            //                 if (res.data.code === 200) {
            //                     // if (this.chart != null && this.chart != "" && this.chart != undefined) {
            //                     //     this.isShowMap = false
            //                     // }
            //                     // this.$nextTick(() => {
            //                     //     this.isShowMap = true
            //                     //     this.$nextTick(() => {
            //                     this.region = res.data.result.map
            //                     this.dataInfo.childMap = a[0].childMap
            //                     // console.log(this.dataInfo, 'a[0].childMap');
            //                     // this.drawMap(this.region, a[0].childMap)
            //                     this.getList()
            //                     //     })
            //                     // })

            //                     // this.getData()
            //                 }
            //             })
            //         }
            //     })


            // });
        },
        setLineData(data, dom, name) {
            const colors = ['#0EDAE2', '#106BDC', '#5931FC'];
            const legend = [];
            const series = [];
            let xAxis = [];
            data.forEach((item, index) => {
                legend.push({
                    name: item.title,
                    textStyle: { color: colors[index] },
                    icon: 'circle',
                    itemWidth: 4,
                    itemhight: 4,
                })
                xAxis = item.label
                series.push({
                    name: item.title,
                    type: "line",
                    lineStyle: {
                        width: 2,
                    },
                    color: colors[index],
                    data: item.value,
                })
            })
            const line = {
                dom,
                xAxis,
                name,
                legend: {
                    data: legend,
                    // x: 'right',
                    // y: 'top',
                    top: "5%",
                    right: "4%",
                    itemWidth: 8,
                    itemHeight: 8,
                    padding: [10, 0, 0, 0],
                },
                series: series
            }
            this.lineChart(line)
        },
        lineChart(data) {
            var linechart = this.$echarts.init(document.getElementById(data.dom))
            linechart.clear();
            linechart.setOption({
                color: ['#106BDC', '#0EDAE2', '#5931FC'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    // borderWidth: 2,
                    // textStyle: {
                    //     color: '#fff',
                    // },
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: data.legend,
                grid: {
                    top: '25%',
                    left: '7%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                        // rotate: 30
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true
                    },
                    data: data.xAxis,
                },
                yAxis: {
                    name: data.name ? '元(斤)' : data.name || '金额(万)',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 38, 0, 0],
                        lineHeight: 30,
                        // align:'left'
                    },
                    // nameLocation:'end',
                    type: 'value',
                    splitNumber: 4,
                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: 'rgba(85, 193, 255, 1)',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                },
                series: data.series,
            })
            window.addEventListener('resize', () => {
                linechart.resize()
            })
        },
        setRingChart(dataList) {
            this.optionData = dataList.map(item => {
                item.name = item.label
                item.y = +item.value / 3
                item.h = +item.value / 3
                return item
            })
            this.ringChart()
        },
        ringChart() {
            // 修改3d饼图绘制过程
            let each = HighCharts.each,
                round = Math.round,
                cos = Math.cos,
                sin = Math.sin,
                deg2rad = Math.deg2rad;
            HighCharts.wrap(HighCharts.seriesTypes.pie.prototype, 'translate', function (proceed) {
                proceed.apply(this, [].slice.call(arguments, 1));
                // Do not do this if the chart is not 3D
                if (!this.chart.is3d()) {
                    return;
                }
                var series = this,
                    chart = series.chart,
                    options = chart.options,
                    seriesOptions = series.options,
                    depth = seriesOptions.depth || 0,
                    options3d = options.chart.options3d,
                    alpha = options3d.alpha,
                    beta = options3d.beta,
                    z = seriesOptions.stacking ? (seriesOptions.stack || 0) * depth : series._i * depth;
                z += depth / 2;
                if (seriesOptions.grouping !== false) {
                    z = 0;
                }
                each(series.data, function (point) {
                    var shapeArgs = point.shapeArgs,
                        angle;
                    point.shapeType = 'arc3d';
                    var ran = point.options.h;
                    shapeArgs.z = z;
                    shapeArgs.depth = depth * 0.75 + ran;
                    shapeArgs.alpha = alpha;
                    shapeArgs.beta = beta;
                    shapeArgs.center = series.center;
                    shapeArgs.ran = ran;
                    angle = (shapeArgs.end + shapeArgs.start) / 2;
                    point.slicedTranslation = {
                        translateX: round(cos(angle) * seriesOptions.slicedOffset * cos(alpha * deg2rad)),
                        translateY: round(sin(angle) * seriesOptions.slicedOffset * cos(alpha * deg2rad))
                    };
                });
            });
            (function (H) {
                H.wrap(HighCharts.SVGRenderer.prototype, 'arc3dPath', function (proceed) {
                    // Run original proceed method
                    var ret = proceed.apply(this, [].slice.call(arguments, 1));
                    ret.zTop = (ret.zOut + 1) / 100;
                    return ret;
                });
            }(HighCharts));

            //日总存煤量

            const offsetHeight =
                document.getElementById("ringChart").offsetHeight;
            HighCharts.chart('ringChart', {
                chart: {
                    type: 'pie',
                    backgroundColor: 'transparent',
                    height: offsetHeight,
                    events: {
                        load: function () {
                            let each = HighCharts.each, points = this.series[0].points;
                            each(points, function (p) {
                                p.graphic.attr({
                                    translateY: -p.shapeArgs.ran
                                });
                                p.graphic.side1.attr({
                                    translateY: -p.shapeArgs.ran
                                });
                                p.graphic.side2.attr({
                                    translateY: -p.shapeArgs.ran
                                });
                            });
                        }
                    },
                    options3d: {
                        enabled: true,
                        alpha: 65
                    },
                },
                title: {
                    text: ''
                },
                legend: { //图例
                    enabled: false,
                },
                tooltip: {
                    enabled: false,
                },
                credits: {
                    enabled: false,
                },
                plotOptions: {
                    pie: {
                        center: ['50%', '60%'],
                        size: 180,
                        innerSize: 100,
                        colors: ['#0085FE', '#00E2FC', '#0085FE', '#00C6FC']
                    }
                },
                series: [
                    {
                        name: '青磁窑矿',
                        data: this.optionData,
                        showInLegend: true,
                        dataLabels: {
                            crop: false,
                            padding: -10,
                            shadow: true,
                            style: {
                                fontSize: '12px',
                                color: "#fff",
                            },
                            formatter: function () {
                                return '<p style="color: #6FB6FF">' + this.key + '' + (this.y / this.total * 100).toFixed(2) + '%</p>';
                            },
                        },
                    }
                ]
            })
        },
        setBarData(barData) {
            const series = []
            const legend = []

            barData.data.forEach((item, index) => {
                legend.push({
                    name: item.title,
                    textStyle: { color: index === 0 ? '#5931FC;' : '#0EDAE2;' },
                })
                series.push({
                    name: item.title,
                    type: 'bar',
                    barWidth: '10',
                    barGap: 0,
                    data: item.value,
                    emphasis: {
                        focus: "series",
                    },
                    backgroundStyle: {
                        color: 'rgba(44, 118, 254, 0.2)'
                    },
                    itemStyle: {
                        opacity: 0.8,
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 1,
                                color: item.colors[0],
                            },
                            {
                                offset: 0,
                                color: item.colors[1],
                            },
                        ]),
                    },
                })
            })
            const chartData = {
                dom: barData.dom,
                xAxis: barData.data[0].label,
                series: series,
            }
            if (legend.length > 1) {
                chartData.legend = {
                    data: legend,
                    // x: 'right',
                    // y: 'top',
                    itemWidth: 10,
                    itemHeight: 10,
                    // top: "10%",
                    right: "5%",
                    padding: [10, 0, 0, 0],
                }
            }
            this.barChart(chartData)
        },
        barChart(data) {
            var barchart = this.$echarts.init(document.getElementById(data.dom))
            // 隐藏动画加载效果。
            barchart.clear();
            barchart.setOption({
                title: {
                    text: data.title ? data.title : '',
                    textAlign: 'left',
                    textStyle: {
                        color: '#00DAC8', // 主标题文字的颜色。
                        fontSize: 18, // 字体大小
                        lineHeight: '30', // 行高
                    },
                    triggerEvent: false, // 是否触发事件
                    x: 'center',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    // borderWidth: 2,
                    // textStyle: {
                    //     color: '#fff',
                    // },
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: data.legend || '',
                grid: {
                    top: '25%',
                    left: data.dom == 'barChart1' ? '9%' : '10%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                        // rotate: 30,
                        // interval: 'auto',
                        textStyle: {
                            fontSize: 12
                        },
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true,
                        // interval: 0,
                        // alignWithLabel:1,
                        lineStyle: {
                            dashOffset: 5
                        },
                        // length:10
                    },
                    data: data.xAxis,
                },
                yAxis: {
                    name: '金额(万)',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 50, 0, 0],
                        lineHeight: 30,
                    },
                    type: 'value',
                    splitNumber: 4,
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisTick: { show: false },

                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: '#6FB6FF',
                        },
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                        textStyle: {
                            fontSize: 12
                        }
                    },
                },
                series: data.series,
            })
            window.addEventListener('resize', () => {
                barchart.resize()
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.bank_title {
    position: relative;

    .gobcak {
        width: .875rem;
        height: .4375rem;
        position: absolute;
        z-index: 99;
        bottom: -0.35rem;
        left: 0.25rem;
        font-size: .2rem;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #00E0DB;
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
            width: .3rem;
            height: .3rem;
        }

        span {
            margin-left: .05rem;
        }
    }
}

.content {
    position: relative;
    box-sizing: border-box;
    padding: 0.15rem 0.24rem;
    // min-height: calc(100vh - 1rem);
    min-height: 12.5rem;

    // background-image: url("../../assets/bg-hhr.png");
    // background-size: 100% 100%;
    video {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        width: 100%;
        height: 100%;
    }

    .time_box {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-top: -0.2rem;

        .time_item {
            // padding: 0.05rem 0.09rem;
            width: 0.75rem;
            height: 0.38rem;
            text-align: center;
            line-height: .38rem;
            border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
            // background: rgba(255, 255, 255, 0.0902);
            margin-right: 0.13rem;
            cursor: pointer;
            font-size: 0.18rem;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            // color: rgba(255, 255, 255, 0.6);
            color: #A3D8D6;
        }

        .active_item {
            background: rgba(255, 255, 255, 0.2) !important;
            // opacity: 1;
            color: #00E0DB !important;
            opacity: 1 !important;
        }
    }

    .t {
        display: flex;
        margin-top: .23rem;

        .t_l {
            width: 10.54rem;
            height: 11.74rem;
            // height: 7.38rem;
            background: linear-gradient(-260deg, rgba(0, 241, 238, 0.1) 0%, rgba(0, 223, 218, 0) 100%);
            border-top: 0.01rem solid rgba(0, 224, 219, 0.3);

            .server {
                width: 6.25rem;
                height: 0.48rem;
            }

            .t_l_content {
                width: 10.54rem;
                height: 7rem;
                // padding-top: 0.01rem;
                // background-image: url("../../assets/bg_007.png");
                // background-size: 100% 100%;
                // background: linear-gradient(180deg, rgba(0, 241, 238, 0.1) 0%, rgba(0, 223, 218, 0) 100%);
                // border-top: 0.01rem solid rgba(0, 224, 219, 0.3);

                .total_data_item {
                    // margin-top: .8rem;
                }

                .map {
                    width: 100%;
                    // height: 5.3rem;
                    height: 7.3rem;
                    margin-top: .5rem;
                }
            }

            // .time_box {
            //     display: flex;
            //     margin-top: -0.1rem;

            //     .time_item {
            //         // padding: 0.05rem 0.09rem;
            //         width: 0.88rem;
            //         height: 0.38rem;
            //         text-align: center;
            //         line-height: .38rem;
            //         border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
            //         // background: rgba(255, 255, 255, 0.0902);
            //         margin-right: 0.13rem;
            //         cursor: pointer;
            //         font-size: 0.23rem;
            //         font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            //         font-weight: 400;
            //         // color: rgba(255, 255, 255, 0.6);
            //         color: #A3D8D6;
            //     }

            //     .active_item {
            //         background: rgba(255, 255, 255, 0.2) !important;
            //         // opacity: 1;
            //         color: #00E0DB !important;
            //         opacity: 1 !important;
            //     }
            // }
        }

        .t_c {
            width: 6.25rem;
            // height: 7.25rem;
            height: 11.74rem;
            // background-image: url("../../assets/bg_008.png");
            // background-size: 100% 100%;
            background: linear-gradient(-220deg, rgba(0, 222, 217, 0.1) 25%, rgba(0, 223, 218, 0.01) 74%);
            border-top: 0.01rem solid rgba(0, 224, 219, 0.3);
            margin-left: 0.25rem;

            .line_chart {
                width: 100%;
                height: 3.6rem;
            }

            #line_chart {
                width: 100%;
                height:3.6rem;
            }
        }
    }

    .b {
        margin-top: 0.24rem;
        display: flex;

        .b_l {
            width: 10.54rem;
            height: 4.13rem;
            // background-image: url("../../assets/bg_009.png");
            // background-size: 100% 100%;
            background: linear-gradient(360deg, rgba(0, 223, 218, 0.1) 19%, rgba(0, 223, 218, 0.01) 88%);
            border-bottom: 0.01rem solid rgba(0, 224, 219, 0.3);

            .server {
                width: 6.25rem;
                height: 0.48rem;
            }

            .line_chart3 {
                width: 10.5rem;
                height: 2.7rem;
                margin-left: .4rem;
            }
        }

        .b_r {
            width: 12.79rem;
            height: 4.13rem;
            // background-image: url("../../assets/bg_009.png");
            // background-size: 100% 100%;
            background: linear-gradient(360deg, rgba(0, 223, 218, 0.1) 19%, rgba(0, 223, 218, 0.01) 88%);
            border-bottom: 0.01rem solid rgba(0, 224, 219, 0.3);
            margin-left: 0.25rem;

            .total_data {
                display: flex;
                margin-top: 0.3rem;

                .total_data_item {
                    display: flex;
                    margin-left: 0.3rem;
                    flex: none;
                }
            }

            .server {
                width: 6.25rem;
                height: 0.48rem;
            }

            .bar_chart2 {
                width: 100%;
                height: 2.7rem;
            }
        }
    }

    .title {
        font-size: 0.23rem;
        font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
        font-weight: 500;
        color: #FAFAFA;
        margin-top: 0.38rem;
        margin-left: 0.2rem;
    }

    .total_data {
        display: flex;
        margin-top: 0.8rem;

        .total_data_item {
            display: flex;
            margin-left: 0.3rem;
            flex: 1;

            img {
                // width: 0.68rem;
                // height: 0.67rem;
            }

            div {
                display: flex;
                flex-direction: column;
                margin-left: 0.2rem;

                label {
                    font-size: 0.15rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;
                    margin-top: 0.2rem;
                }

                span {
                    font-size: 0.38rem;
                    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                    font-weight: bold;
                    color: #00E0DB;


                    // margin-top: 0.2rem;
                }

                .num {
                    display: flex;
                    flex-direction: row;
                    margin: 0;

                    .ratio {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        color: #00FF9D;
                        margin-top: 0.16rem;

                        label {
                            font-size: 0.15rem;
                            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                            font-weight: 500;
                            color: #00FF9D;
                        }

                        span {
                            margin: 0 0.1rem;
                            font-size: 0.15rem;
                            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                            font-weight: 500;
                            color: #00FF9D;
                        }

                        // img {
                        //     width: 0.3rem;
                        //     height: 0.3rem;
                        // }
                    }

                    .ratio_up {
                        font-size: 0.15rem;
                        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                        font-weight: 500;
                        color: #FF5A0D;

                        label {
                            font-size: 0.15rem;
                            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                            font-weight: 500;
                            color: #FF5A0D;
                        }

                        span {
                            font-size: 0.15rem;
                            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                            font-weight: 500;
                            color: #FF5A0D;
                        }
                    }
                }
            }
        }
    }

    .subtitle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // margin-top: 0.24rem;
        margin:.5rem 0.19rem;
        margin-left: .25rem;

        .subtitle_txt {
            width: 3.45rem;
            height: 0.38rem;
            line-height: 0.38rem;
            padding-left: 0.23rem;
            font-size: 0.2rem;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #FAFAFA;
            background-image: url("../../assets/title_bg_001.png");
            background-size: 100% 100%;
        }

        .tab_box {
            display: flex;

            .tab_item {
                font-size: 0.12rem;
                font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
                font-weight: 400;
                color: #FFFFFF;
                background: rgba(255, 255, 255, 0.0902);
                padding: 0.05rem 0.08rem;
                box-sizing: border-box;
                margin: 0.06rem;
                cursor: pointer;
            }

            .active {
                background: #286AE7;
            }
        }

        .el-dropdown-link {
            background: rgba(255, 255, 255, 0.0902);
            padding: 0.05rem 0.19rem;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.6);
        }
    }

    .server {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.48rem;
        background: linear-gradient(119deg, rgba(0, 222, 217, 0.3) 19%, rgba(0, 223, 218, 0) 70%);

        // padding-top: .24rem;
        .card_ {
            font-size: 0.23rem;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #00E0DB;
            padding-left: .25rem;
        }

        .date {
            // margin-left: 1.2rem;
            color: #7B8A89;
            padding-right: 0.15rem;

            span {
                // padding: .03rem .05rem;
                display: inline-block;
                width: 0.44rem;
                height: 0.23rem;
                text-align: center;
                line-height: .23rem;
                border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                font-size: 0.13rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                background: rgba(255, 255, 255, 0.05);
                opacity: .5;
                font-weight: 400;
                cursor: pointer;
            }

            span:nth-child(2) {
                margin: 0 .13rem;
            }
        }
    }

    .active {
        background: rgba(255, 255, 255, 0.2) !important;
        // opacity: 1;
        color: #00E0DB !important;
        opacity: 1 !important;
    }

    .add {
        display: flex;
        margin-top: .5rem;
        margin-left: .5rem;

        .add_item {
            display: flex;
            flex-direction: column;
            margin-right: 0.2rem;

            div {
                font-size: 0.15rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 0.18rem;
                padding-top: .1rem;

                span:nth-child(2) {
                    margin-left: .14rem;
                    font-size: 0.15rem;
                    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                    font-weight: 500;
                    color: #FF5A0D;
                    line-height: 0.18rem;

                    i {
                        font-style: normal;
                    }
                }

                img {
                    margin-left: .1rem !important;
                }
            }

            .num {
                display: block;
                font-size: 0.38rem;
                font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                font-weight: bold;
                color: #00E0DB;
                // line-height: 0.38rem;
                // padding-top: .11rem;
                // padding-left: .08rem;
            }

            div {
                min-width: 3rem;
            }

        }
    }

    .block {
        // margin-top: .38rem;
        // margin-left: .25rem;
        display: flex;
        align-items: center;

        span:nth-child(1) {
            width: 0.11rem;
            height: 0.2rem;
            background: #00E0DB;
            border-radius: 0rem 0rem 0rem 0rem;
            opacity: 1;
        }


        span:nth-child(2) {
            margin-left: .15rem;
            font-size: 0.2rem;
            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
            font-weight: bold;
            color: #00E0DB;
        }
    }
}

.pos-btn {
    position: fixed;
    right: 10%;
    bottom: 20%;
    background-color: transparent;
    border: none;
    outline: none;
    width: 40px;
    height: 40px;
    cursor: pointer;
    padding: 0;
}

.pos-btn img {
    width: 100%;
    height: 100%;
}

::v-deep .active-ring-name {
    font-size: .23rem !important;
    padding-top: .1rem;
}
</style>